import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, Input, Directive, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@fa-switch-sharedservices/ng-elements/common';
import { FadvBaseComponent, FadvIconLibraryService, Forward, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/icon/icon';
import { getIconProperties } from '@fa-switch-sharedservices/web-elements/utilities/document-icon-utils';

class FadvIconComponent extends FadvBaseComponent {
    constructor(element, iconService) {
        super(element);
        this.name = '';
        this.label = '';
        iconService.initialize();
    }
}
FadvIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvIconComponent, deps: [{ token: ElementRef }, { token: FadvIconLibraryService }], target: i0.ɵɵFactoryTarget.Component });
FadvIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvIconComponent, selector: "fadv-icon", inputs: { library: "library", name: "name", label: "label", src: "src", foreground: "foreground", background: "background", outline: "outline", size: "size" }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    Forward()
], FadvIconComponent.prototype, "library", void 0);
__decorate([
    Forward()
], FadvIconComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvIconComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvIconComponent.prototype, "src", void 0);
__decorate([
    Forward()
], FadvIconComponent.prototype, "foreground", void 0);
__decorate([
    Forward()
], FadvIconComponent.prototype, "background", void 0);
__decorate([
    Forward()
], FadvIconComponent.prototype, "outline", void 0);
__decorate([
    Forward()
], FadvIconComponent.prototype, "size", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-icon',
                    template: '',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }, { type: i1.FadvIconLibraryService, decorators: [{
                        type: Inject,
                        args: [FadvIconLibraryService]
                    }] }];
    }, propDecorators: { library: [{
                type: Input
            }], name: [{
                type: Input
            }], label: [{
                type: Input
            }], src: [{
                type: Input
            }], foreground: [{
                type: Input
            }], background: [{
                type: Input
            }], outline: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class FadvDocumentIconDirective {
    constructor(icon) {
        this.icon = icon;
    }
    set fadvDocumentIcon(contentType) {
        const props = getIconProperties(contentType);
        this.icon.name = props.name || '';
        this.icon.library = props.library;
        this.icon.foreground = props.foreground;
    }
}
FadvDocumentIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDocumentIconDirective, deps: [{ token: FadvIconComponent }], target: i0.ɵɵFactoryTarget.Directive });
FadvDocumentIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvDocumentIconDirective, selector: "fadv-icon[fadvDocumentIcon]", inputs: { fadvDocumentIcon: "fadvDocumentIcon" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvDocumentIconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'fadv-icon[fadvDocumentIcon]',
                }]
        }], ctorParameters: function () {
        return [{ type: FadvIconComponent, decorators: [{
                        type: Inject,
                        args: [FadvIconComponent]
                    }] }];
    }, propDecorators: { fadvDocumentIcon: [{
                type: Input
            }] } });

class FadvIconModule {
}
FadvIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvIconModule, declarations: [FadvIconComponent, FadvDocumentIconDirective], imports: [FadvCommonModule], exports: [FadvIconComponent, FadvDocumentIconDirective] });
FadvIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvIconModule, providers: [FadvIconLibraryService], imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvIconComponent, FadvDocumentIconDirective],
                    imports: [FadvCommonModule],
                    exports: [FadvIconComponent, FadvDocumentIconDirective],
                    providers: [FadvIconLibraryService],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvDocumentIconDirective, FadvIconComponent, FadvIconModule };
